import { sendGet } from './axios';

// eslint-disable-next-line import/prefer-default-export
export const getAllResource = () => sendGet('/idol/resources');
